import React from 'react';
import { withTranslation } from "react-i18next";
import CaProfileBadgesView from "./CaProfileBadgesView";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firebaseConnect, getVal } from 'react-redux-firebase';
import { getBadges } from '../../helpers/computeBadges';

class CaProfileBadgesContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: []
        };
    }

    getData() {
        return getBadges().then(res => res.badges.map(badge => {
            if (this.props.result.badges&&this.props.result.badges[badge.id])
                return {
                    badgeImg: badge.icon,
                    badgeName: badge.name,
                    badgeDescription: badge.description
                }
            else
                return null;
        }).filter(r => r));
    }

    componentDidMount() {
        this.getData().then(data => this.setState({data, loading: false}));
    }

    render() {
        return (
            <CaProfileBadgesView
                badges={this.state.data}
                body={this.props.t('account_page.badges.body')}
            />
        )
    }
}

export default compose(
    connect((state) => ({
        result: getVal(state.firebase, `data/quiz/${state.firebase.auth.uid}/`)
    }),{}),
    firebaseConnect((props, store) => [
        `quiz/${store.getState().firebase.auth.uid}`
    ]),
)(withTranslation("translations")(CaProfileBadgesContainer));
